module.exports = __webpack_public_path__ + "img/logo.c1b88d16.svg";